﻿import {GlobalConfig, GlobalContext} from "../contexts/GlobalContext";

export function getGlobalContext(): GlobalConfig {
	return GlobalContext.getData();
}
